
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"1 -0.15 14 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.026 2.831L7.064.149c.44-.199.957-.199 1.397 0l6.037 2.682a1.732 1.732 0 011.026 1.578v4.054c0 4.787-3.312 9.263-7.762 10.35C3.312 17.725 0 13.25 0 8.462V4.409c0-.681.405-1.302 1.026-1.578zm2.165 7.96l2.234 2.235a.859.859 0 001.216 0l5.684-5.684a.859.859 0 10-1.216-1.216l-5.072 5.071-1.63-1.621a.859.859 0 10-1.216 1.216z","fill":"currentColor"}})])
          )
        }
      }
    